// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tSJx","content":"styles_content__I6JsB"};